// extracted by mini-css-extract-plugin
export var displayNone = "_ry-6";
export var imgContainer = "_ry-2";
export var overflowHidden = "_ry-3";
export var productInfoCardButtonContainer = "_ry-5";
export var productTitleText = "_ry-4";
export var rightArrow = "_ry-1";
export var rightArrowContainer = "_ry-0";